module.exports = __webpack_public_path__ + "img/external-link.a8aa3518.svg";